// extracted by mini-css-extract-plugin
export default {"class":"groups_class__eNc2U","donateButton":"groups_donateButton__MCGCV","popLinks":"groups_popLinks__2J2Mi","thumb":"groups_thumb__WEDtm"};